import React from 'react'
import styled from 'styled-components'
import { PageProps, Link } from 'gatsby'

import CMS from '@talus-analytics/library.airtable-cms'
import Providers, {
  Config,
  LandingPageOptions,
} from 'components/layout/Providers'

import { ContentContainer, Main, Nav, Footer, Layout } from 'components/layout'
import { ActionButton, RichText } from 'components/ui'
import useLandingPageData from 'cmsHooks/useLandingPageData'
import ResourceSearch from '../../landingComponents/ResourceSearch'
import LandingOptions from '../../landingComponents/LandingOptions'
import device from 'utilities/device'

const Tagline = styled.p`
  ${({ theme }) => theme.textStyleTagLine}
  font-weight: 600;
  color: ${({ theme }) => theme.text};
  padding: 1.5rem 0;
`
const Grid = styled.div`
  display: grid;
  column-gap: 5%;
  grid-template-columns: 48% 47%;
  @media (max-width: 1200px) {
    grid-template-columns: 50% 42%;
  }
  margin-bottom: 3rem;
  @media ${device.laptop} {
    display: flex;
    flex-direction: column-reverse;
  }
`
const Spacer = styled.div`
  padding-top: 2em;
`
const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
const Image = styled(CMS.Image)`
  @media ${device.laptop} {
    max-height: 20rem;
    margin: 0 auto 2rem auto;
  }
`
interface LandingConfig extends Config {
  options: {
    exploreSection: 'carousel' | 'grid' | 'none'
  }
}
const LandingPage = ({ pageContext }: PageProps): JSX.Element => {
  const data = useLandingPageData()

  // cast pageContext to correct type
  const config = pageContext as LandingConfig

  return (
    <Providers config={config}>
      <Layout>
        <CMS.SEO />
        <Nav />
        <Main>
          <ContentContainer>
            <Grid>
              <Left>
                <h1>
                  <CMS.Text data={data} name="First header" />
                </h1>
                <Tagline>
                  <CMS.Text data={data} name="Tagline" />
                </Tagline>
                <RichText>
                  <CMS.RichText data={data} name="Paragraph text" />
                </RichText>
                <Spacer />
                {config.siteMap.explore.url && (
                  <ActionButton as={Link} to={config.siteMap.explore.url}>
                    <CMS.Text data={data} name="Button text" />
                  </ActionButton>
                )}
                <Spacer />
                <ResourceSearch />
              </Left>
              <Image data={data} name="Left image" />
            </Grid>
          </ContentContainer>
          {config && (
            <LandingOptions
              exploreSection={
                config.options.exploreSection as LandingPageOptions
              }
            />
          )}
        </Main>
        <Footer />
      </Layout>
    </Providers>
  )
}

export default LandingPage
